function initLazyFadeImages() {
    const lazyImages = document.querySelectorAll('.lazy-fade-image');

    lazyImages.forEach(wrapper => {

      if (wrapper.__lazyFadeInit) return;
      wrapper.__lazyFadeInit = true;

      const realImg = wrapper.querySelector('.real-img');
      const placeholder = wrapper.querySelector('.placeholder-img');

      if (!realImg || !placeholder) return;

      let hasFaded = false;

      const runFade = () => {
        if (hasFaded) return;
        hasFaded = true;

        placeholder.classList.add('hide-placeholder');
        realImg.classList.add('show-real');
      };

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;

          observer.disconnect();

          // Minimum delay
          setTimeout(() => {
            if (realImg.complete && realImg.naturalWidth > 0) {
              runFade();
            } else {
              realImg.addEventListener('load', runFade, { once: true });
            }
          }, 1000);

          // Safety fallback
          setTimeout(runFade, 3000);
        },
        { rootMargin: '200px' } // preload before visible
      );

      observer.observe(wrapper);

    });

}

// Universal setup for lazy images: Run on load and observe body for mutations (works on all pages like search, collection, etc.)
document.addEventListener('DOMContentLoaded', () => {
  initLazyFadeImages();  // Initial call on page load
});

let lazyInitScheduled = false;
const bodyObserver = new MutationObserver(() => {
  if (lazyInitScheduled) return;
  lazyInitScheduled = true;

  requestAnimationFrame(() => {
    lazyInitScheduled = false;
    initLazyFadeImages();
  });
});

bodyObserver.observe(document.body, { childList: true, subtree: true });

// Collection Card Images Slider (unchanged, as it's already working)
(function () {
  'use strict';
  // Keep track of Swiper instances
  const swiperInstances = {};

  // Function to initialize sliders
  function initProductSliders(slider) {
    const id = slider.id;
    let initialSlide = 0;
        // Only on Mobile Slide Second Product Images One on Load
    if( window.innerWidth <= 767 ){
        const second_product_id  = document.querySelector('.product-card:nth-child(2)').getAttribute('data-product-id');
        if( 'product-'+second_product_id+'-slider' == id ){
          initialSlide = 2;
        }
    }

    const count = Number(slider.dataset.images_count) || 0;
    console.log('Initializing slider:', id, 'with count:', count);  // Debug log
    if (!id || count === 0) {
      console.log('Skipping slider due to missing id or count');  // Debug log
      return;
    }

    // Destroy old instance if exists
    if (swiperInstances[id]) {
      swiperInstances[id].destroy(true, true);
      delete swiperInstances[id];
    }

    // Initialize new Swiper
    swiperInstances[id] = new Swiper(`#${id}`, {
      initialSlide: initialSlide,
      loop: count > 1,
      slidesPerView: 1,
    //   lazy: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2
      },
      preloadImages: false,
      on: {
        init(swiper) {
          if( initialSlide > 0 ){
            // delay before moving to the first slide
            setTimeout(() => {
              swiper.slideTo(0);
            }, 1000); // 1 second delay
          }
        }
      },
      navigation: {
        nextEl: `#${id} .swiper-button-next`,
        prevEl: `#${id} .swiper-button-prev`,
      },
    });

    // Optional: reset on mouse leave
    slider.addEventListener('mouseleave', () => {
      swiperInstances[id].slideToLoop(0);
    });
  }

  // Observe DOM for AJAX-added sliders
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          const sliders = node.querySelectorAll('.product-slider');
          sliders.forEach((slider) => initProductSliders(slider));

          // If the node itself is a slider
          if (node.classList.contains('product-slider')) {
            initProductSliders(node);
          }
        }
      });
    });
  });

  // Start observing body
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial load
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-slider').forEach((slider) => initProductSliders(slider));
  });
})();
